import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap";

export default class extends Controller {
  static values = {
    timeout: { type: Number, default: 5000 }
  }

  connect() {
    if (this.element.classList.contains("fade-in")) {
      this.fadeIn()
    }

    if (this.timeoutValue > 0) this.fadeOut()
  }

  fadeIn() {
    this.element.style.opacity = "0"
    this.element.style.transition = this.element.style.transition || "opacity 250ms ease-in-out"

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.element.style.opacity = "1"
      })
    })
  }

  fadeOut() {
    setTimeout(() => {
      const alertElement = this.element;

      if (alertElement.classList.contains("fade-in")) {
        alertElement.style.opacity = "0"
        setTimeout(() => {
          bootstrap.Alert.getOrCreateInstance(alertElement).close()
        }, 250)
        return
      }

      const bsAlert = new bootstrap.Alert(alertElement);
      bsAlert.close(); // Triggers the closing animation

      // Optionally, listen for the 'closed.bs.alert' event to do something after the alert closes
      alertElement.addEventListener('closed.bs.alert', () => {
        // Alert has been closed and removed from DOM

      });
    }, this.timeoutValue);
  }

  fadeAndSlide(element) {
    const fadeDuration = 2000;
    const slideDuration = 500;

    // Step 1: Fade out the element
    let opacity = 1;
    const fadeInterval = setInterval(function () {
      if (opacity > 0) {
        opacity -= 0.1;
        element.style.opacity = opacity;
      } else {
        clearInterval(fadeInterval);
        // Step 2: Slide up the element
        let height = element.offsetHeight;
        const slideInterval = setInterval(function () {
          if (height > 0) {
            height -= 10;
            element.style.height = height + "px";
          } else {
            clearInterval(slideInterval);
            // Step 3: Remove the element from the DOM
            element.parentNode.removeChild(element);
          }
        }, slideDuration / 10);
      }
    }, fadeDuration / 10);
  }

}
